import ReportHelper from "neon-frontend-utils/src/components/Report/helpers/ReportHelper";
import Logger from "neon-frontend-utils/src/logger";
import Components from "../../../constants/Components";
import * as actionType from "./../constants/ActionTypes";

const initialState = {
    detailPageContent: {},
    reportData: {
        config: [],
        consultant: {
            consultantName: "",
        },
        loaded: false,
        organisation: {
            logo: null,
            organisationName: "",
        },
        participant: {
            appointmentDate: "",
            educationLevel: "",
            firstName: "",
            infix: "",
            language: "",
            lastName: "",
        },
        permission: "",
        product: {
            productName: "",
            translationKey: "",
        },
        project: {
            projectName: "",
            projectType: "",
        },
        reportSlug: "",
        sections: {},
        sectionsMissing: [],
    },
};

const gatherSectionsMissing = (reportData) => {
    if (reportData.scoreMissing === false) {
        return [];
    }

    return Object.values(reportData.sections)
        .filter((section) => section.completed === false)
        .map((section) => section.handle);
};

/**
 * Returns the new state
 * @param {Object} state - state
 * @param {Object} action - action
 * @returns {Object} new state
 */
export default function reportReducer(state = initialState, action) {
    const newState = Object.assign({}, state);

    switch (action.type) {
        case actionType.GET_REPORT_DATA:
            try {
                newState.reportData = { ...initialState.reportData };
                newState.reportData.reportSlug = action.reportData.reportSlug;
                newState.reportData.reportId = action.reportData.reportId;

                if (action.reportData.participant) {
                    newState.reportData.participant = ReportHelper.getParticipant(action.reportData.participant);
                }

                if (action.reportData.product) {
                    newState.reportData.product = ReportHelper.getProduct(action.reportData.product);
                }

                if (action.reportData.project) {
                    newState.reportData.project = ReportHelper.getProject(action.reportData.project);
                }

                if (action.reportData.organisation) {
                    newState.reportData.organisation = ReportHelper.getOrganisation(action.reportData.organisation);
                }

                if (action.reportData.consultant) {
                    newState.reportData.consultant = ReportHelper.getConsultant(action.reportData.consultant);
                }

                newState.reportData.config = ReportHelper.getUIConfig(action.reportData, newState);
                newState.reportData.permission = action.reportData.permission;
                newState.reportData.viewedOn = action.reportData.viewedOn;
                newState.reportData.showMoreInfoModal = action.reportData.showMoreInfoModal;
                newState.reportData.completedOn = action.reportData.completedOn;
                newState.reportData.generatedPdfReport = action.reportData.generatedPdfReport;
                newState.reportData.sectionsMissing = gatherSectionsMissing(action.reportData);
                newState.reportData.loaded = true;
                newState.reportData.sharedWithParticipant = action.reportData.sharedWithParticipant || null;
                newState.reportData.assessmentType = action.reportData.assessmentType || null;
                newState.reportData.isSummaryActive = action.reportData.isSummaryActive;
                newState.reportData.name = action.reportData.name;
            } catch (error) {
                Logger.instance.error({
                    component: Components.REPORT,
                    error,
                    message: "Exception in Report reducer GET_REPORT",
                });
            }

            break;

        case actionType.GET_REPORT_DETAIL_DATA:
            try {
                if (action.reportDetailData.scores) {
                    action.reportDetailData.scores.forEach((score) => {
                        score.displayScores = score.scoreTypes || {};
                    });
                }

                newState.detailPageContent = action.reportDetailData;
            } catch (error) {
                Logger.instance.error({
                    component: Components.REPORT,
                    error,
                    message: "Exception in Report reducer GET_REPORT_DETAIL_DATA",
                });
            }

            break;

        case actionType.SET_PDF_REPORT_DATA:
            try {
                let newGeneratedPdfReport = [...newState.reportData.generatedPdfReport];

                if (newGeneratedPdfReport.find((pdfReport) => pdfReport.type === action.pdfReportData.type)) {
                    newGeneratedPdfReport = newGeneratedPdfReport.map((pdfReport) =>
                        pdfReport.type === action.pdfReportData.type ? action.pdfReportData : pdfReport,
                    );
                } else {
                    newGeneratedPdfReport.push(action.pdfReportData);
                }
                newState.reportData = {
                    ...newState.reportData,
                    generatedPdfReport: newGeneratedPdfReport,
                };
            } catch (error) {
                Logger.instance.error({
                    component: Components.REPORT,
                    error,
                    message: "Exception in Report reducer SET_PDF_REPORT_DATA",
                });
            }
            break;

        case actionType.RESET_REPORT_DATA:
            try {
                newState.reportData = initialState.reportData;
                newState.detailPageContent = initialState.detailPageContent;
            } catch (error) {
                Logger.instance.error({
                    component: Components.REPORT,
                    error,
                    message: "Exception in Report reducer RESET_REPORT",
                });
            }

            break;

        case actionType.RESET_REPORT_DETAIL_DATA:
            try {
                newState.detailPageContent = {};
            } catch (error) {
                Logger.instance.error({
                    component: Components.REPORT,
                    error,
                    message: "Exception in Report reducer RESET_REPORT_DETAIL_DATA",
                });
            }

            break;

        default:
            return state;
    }
    return newState;
}
